(() => {
  if (!document.querySelector('.ohmm-premium') || document.documentElement.dataset.premiumEarbudsBound) return;
  document.documentElement.dataset.premiumEarbudsBound = 'true';
  const es = document.documentElement.lang.startsWith('es') || location.pathname.includes('auriculares-');
  const header = document.querySelector('.header');
  if (header) {
    let nav = header.querySelector('nav[aria-label="Product information"],.ohmm-smart-header-nav');
    if (!nav) {
      nav = document.createElement('nav');
      const icons = header.querySelector('.header__icons');
      if (icons) header.insertBefore(nav, icons); else header.appendChild(nav);
    }
    nav.className = 'header__inline-menu ohmm-smart-header-nav';
    nav.setAttribute('aria-label', es ? 'Información del producto' : 'Product information');
    nav.innerHTML = `<ul class="ohmm-smart-header-nav__list" role="list"><li><a href="#translation-demo">${es ? 'Cómo funciona' : 'How it works'}</a></li><li><a href="#earbuds-compatibility">${es ? 'Compatibilidad' : 'Compatibility'}</a></li><li><a href="#judgeme_product_reviews">${es ? 'Opiniones' : 'Customer reviews'}</a></li><li><a href="/policies/shipping-policy">${es ? 'Envíos y devoluciones' : 'Shipping & returns'}</a></li></ul>`;
  }
  const update = () => {
    const selected = document.querySelector('.ohmm-earbuds-packs input:checked');
    const pack = selected?.nextElementSibling;
    if (!pack) return;
    const q = Number(selected.value), price = pack.dataset.packPrice;
    const name = es ? `${q} ${q === 1 ? 'pareja' : 'parejas'}` : `${q} ${q === 1 ? 'pair' : 'pairs'}`;
    const primary = document.querySelector('.product-form__submit');
    const span = primary?.querySelector(':scope > span');
    if (span && !primary.disabled) span.textContent = es ? `Añadir ${name} — ${price}` : `Add ${name} to cart — ${price}`;
    const sticky = document.querySelector('.sticky-atc');
    const stickyPrice = sticky?.querySelector('.sticky-atc__price');
    if (stickyPrice) stickyPrice.textContent = price;
    const stickyButton = sticky?.querySelector('button[type="submit"]');
    const stickySpan = stickyButton?.querySelector(':scope > span');
    if (stickySpan && !stickyButton.disabled) stickySpan.textContent = es ? `Añadir ${name}` : `Add ${name}`;
    const mapping = document.querySelector('[data-m76-color-images]');
    const color = document.querySelector('variant-radios input[name="Color"]:checked');
    if (mapping && color) {
      try { const source = JSON.parse(mapping.textContent)[color.value]; if (source) document.querySelectorAll('.ohmm-earbuds-pack__image img').forEach(img => { img.src = source; }); } catch {}
    }
  };
  document.addEventListener('change', event => { if (event.target.closest('.ohmm-earbuds-packs,variant-radios,variant-selects')) update(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, update);
  update();
})();
